<div class="page-wrapper pt-4">
    <div class="">
        <div class="">
            <div class="default_class">
                <div class="content-wrapper p-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="dashboard-content">
                                        <h1 class="page-title">ICT Champion Dashboard</h1>
                                        <p class="page-subtitle">
                                            {{subCountyName}} - Academic Overview
                                        </p>
                                        <!-- DETAILS ROW -->
                                        <div class="row mb-4">
                                            <div class="col-md-4 mb-2">
                                                <div class="stat-card h-100 pointer" (click)="navigationUrlNew(1)">
                                                    <i class="fas fa-users stat-icon"></i>
                                                    <div class="stat-number">
                                                        {{dashboardDetails?.Total_Admitted_Learners?.ACTIVE_LEARNERS}}</div>
                                                    <div class="stat-label">
                                                        Total Active Learners
                                                    </div>
                                                    <div class="stat-sublabel">Currently Enrolled</div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="stat-card h-100 pointer" (click)="navigationUrlNew(2)">
                                                    <i class="fas fa-users stat-icon"></i>
                                                    <div class="stat-number">
                                                        {{dashboardDetails?.Total_Admitted_Learners?.INACTIVE_LEARNERS}}</div>
                                                    <div class="stat-label">
                                                        Total InActive Learners
                                                    </div>
                                                    <div class="stat-sublabel">Currently Enrolled</div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="stat-card h-100 pointer" (click)="navigationUrl()">
                                                    <i class="bi bi-arrow-left-right stat-icon"></i>
                                                    <div class="stat-number">
                                                        {{dashboardDetails?.Total_Transfer_Requests_Received?.REQUESTED_LEARNERS}}
                                                    </div>
                                                    <div class="stat-label">Total Transfer Requests Received</div>
                                                    <div class="stat-sublabel">Current Academic Year</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <!-- CHART & GENDER ROW -->
                                        <div class="row mb-4">

                                            <div class="col-8 mb-2">
                                                <div class="chart-card h-100">
                                                    <div class="chart-header">
                                                        <div class="d-flex align-items-center">
                                                            <i class="fas fa-chart-bar me-2"></i>
                                                            <div>
                                                                <div class="chart-title">
                                                                    DISTRIBUTION OF LEARNERS PER GRADE
                                                                </div>
                                                                <div class="chart-subtitle">
                                                                    Population distribution across all grade levels
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="chart-body">
                                                        <div class="row">
                                                            <div class="col-lg-12 text-center">
                                                                <canvas baseChart [datasets]="barChartData"
                                                                    [labels]="barChartLabels"
                                                                    [options]="barChartOptions"
                                                                    [chartType]="barChartType" [legend]="false">
                                                                </canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 mb-2">
                                                <div class="chart-card h-100">
                                                    <div class="chart-header">
                                                        <div class="d-flex align-items-center">
                                                            <i class="fas fa-chart-pie me-2"></i>
                                                            <div>
                                                                <div class="chart-title">
                                                                    GENDER DISTRIBUTION
                                                                </div>
                                                                <div class="chart-subtitle">
                                                                    Learner Population by gender
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="chart-body">
                                                        <div class="pie-chart-container">
                                                            <div class="pie-chart">
                                                                <svg width="200" height="200" viewBox="0 0 200 200">
                                                                    <circle cx="100" cy="100" r="80" fill="none"
                                                                        stroke="#e9ecef" stroke-width="40" />


                                                                    <circle cx="100" cy="100" r="80" fill="none"
                                                                        stroke="#00adee" stroke-width="40"
                                                                        [attr.stroke-dasharray]="((dashboardDetails?.GENDER_DISTRIBUTION?.MALE || 0) * 502.4) / (dashboardDetails?.GENDER_DISTRIBUTION?.TOTALLEARNERS || 1) + ' 502.4'"
                                                                        stroke-dashoffset="0"
                                                                        transform="rotate(-90 100 100)" />
                                                                    <circle cx="100" cy="100" r="80" fill="none"
                                                                        stroke="#b91c1c" stroke-width="40"
                                                                        [attr.stroke-dasharray]="((dashboardDetails?.GENDER_DISTRIBUTION?.FEMALE || 0) * 502.4) / (dashboardDetails?.GENDER_DISTRIBUTION?.TOTALLEARNERS || 1) + ' 502.4'"
                                                                        [attr.stroke-dashoffset]="'-' + ((dashboardDetails?.GENDER_DISTRIBUTION?.MALE || 0) * 502.4) / (dashboardDetails?.GENDER_DISTRIBUTION?.TOTALLEARNERS || 1)"
                                                                        transform="rotate(-90 100 100)" />
                                                                </svg>
                                                                <div class="pie-center">
                                                                    <div class="pie-total">
                                                                        {{dashboardDetails?.GENDER_DISTRIBUTION?.TOTALLEARNERS}}
                                                                    </div>
                                                                    <div class="pie-label">Total Learners</div>
                                                                </div>
                                                            </div>
                                                            <div class="pie-legend">
                                                                <div class="legend-item">
                                                                    <span class="legend-color"
                                                                        style="background-color: #00adee"></span>
                                                                    <span class="legend-text">Male:
                                                                        {{dashboardDetails?.GENDER_DISTRIBUTION?.MALE}}
                                                                        ({{((dashboardDetails?.GENDER_DISTRIBUTION?.MALE
                                                                        || 0) * 100) /
                                                                        ((dashboardDetails?.GENDER_DISTRIBUTION?.TOTALLEARNERS
                                                                        || 0) || 1) | number:'1.0-0'}}%)</span>
                                                                </div>
                                                                <div class="legend-item">
                                                                    <span class="legend-color"
                                                                        style="background-color: #b91c1c"></span>
                                                                    <span class="legend-text">Female:
                                                                        {{dashboardDetails?.GENDER_DISTRIBUTION?.FEMALE}}
                                                                        ({{((dashboardDetails?.GENDER_DISTRIBUTION?.FEMALE
                                                                        || 0) * 100) /
                                                                        ((dashboardDetails?.GENDER_DISTRIBUTION?.TOTALLEARNERS
                                                                        || 0) || 1) | number:'1.0-0'}}%)</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- BAR CHART ROW -->
                                        <div class="row mb-4">
                                            <div class="col-md-6">
                                                <div class="chart-card h-100">
                                                    <div class="chart-header">
                                                        <div class="d-flex align-items-center">
                                                            <i class="fas fa-bell me-2"></i>
                                                            <div>
                                                                <div class="chart-title">
                                                                    Pending Notifications & Alerts
                                                                </div>
                                                                <div class="chart-subtitle">
                                                                    Real-time alerts and deadlines
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="chart-body">
                                                        <div class="progress-item">
                                                            <div class="progress-label">APPROVAL REQUESTS</div>
                                                            <div class="progress-bar-container">
                                                                <div class="progress-bar-fill warning"
                                                                    [style.width.%]="dashboardDetails?.Pending_Nofications_For_Transfer_Requests?.ACCEPTED_PERCENTAGE">
                                                                </div>
                                                            </div>
                                                            <div class="progress-value">{{
                                                                dashboardDetails?.Pending_Nofications_For_Transfer_Requests?.ACCEPTED
                                                                }}</div>
                                                        </div>
                                                        <div class="progress-item">
                                                            <div class="progress-label">DEAD LINE ALERTS</div>
                                                            <div class="progress-bar-container">
                                                                <div class="progress-bar-fill danger"
                                                                    style="width: 0%; background-color: #ffc107"></div>
                                                            </div>
                                                            <div class="progress-value">0</div>
                                                        </div>
                                                        <div class="progress-item">
                                                            <div class="progress-label">REJECTIONS</div>
                                                            <div class="progress-bar-container">
                                                                <div class="progress-bar-fill primary"
                                                                    [style.width.%]="dashboardDetails?.Pending_Nofications_For_Transfer_Requests?.REJECTED_PERCENTAGE">
                                                                </div>
                                                            </div>
                                                            <div class="progress-value">{{
                                                                dashboardDetails?.Pending_Nofications_For_Transfer_Requests?.REJECTED
                                                                }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Replaced system notifications with gender distribution pie chart -->
                                            <div class="col-md-6">
                                                <div class="chart-card h-100">
                                                    <div class="chart-header">
                                                        <div class="d-flex align-items-center">
                                                            <i class="fas fa-inbox me-2"></i>
                                                            <div>
                                                                <div class="chart-title">
                                                                    Incoming Transfer Requests Queue
                                                                </div>
                                                                <div class="chart-subtitle">
                                                                    Requests awaiting review
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="chart-body">
                                                        <div class="queue-list">
                                                            <div class="queue-item" *ngFor="let item of listGrid">
                                                                <div class="queue-info">
                                                                    <div class="queue-school">{{ item.TNT_NAME }}</div>
                                                                    <div class="queue-student">
                                                                        {{ item.FULLNAME }} - {{ item.MAISHA_ID }}
                                                                    </div>
                                                                </div>
                                                                <div class="queue-actions">
                                                                    <button class="queue-btn approve"
                                                                        *ngIf="[0, 3].includes(item.IS_APPROVED)"
                                                                        (click)="ApproveRej(item, 1)">
                                                                        Approve
                                                                    </button>
                                                                    <button class="queue-btn reject"
                                                                        *ngIf="[0, 3].includes(item.IS_APPROVED)"
                                                                        (click)="rejectreason(item)">
                                                                        Reject
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal" tabindex="-1" id="reject">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Reject Reason</h5>
        <button type="button" class="btn-close" id="rejectClose" data-bs-dismiss="modal" aria-label="Close"
          (click)="comments = ''"></button>
      </div>
      <div class="modal-body">
        <div class="form-group row">
          <label class="col-md-4 control-label">Comments</label>
          <div class="col-md-8 inputGroupContainer">
            <div class="input-group">
              <textarea name="" id="" rows="5" [(ngModel)]="comments" class="form-control"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="comments = ''" id="rejectClose" data-bs-dismiss="modal">
          Close
        </button>
        <button type="button" class="btn btn-save" (click)="ApproveRej(rowData, 2)">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>